/**
 * Emails that send themselves, and what each marketing mail did (ADR-099).
 */
export const AUTOMATIONS = ['review_request', 'win_back', 'repurchase', 'welcome', 'cart_second', 'birthday'];
/** The template each automation sends — worded in Settings → Notifications like every other mail. */
export const AUTOMATION_TEMPLATES = {
    review_request: 'review.request',
    win_back: 'customer.win_back',
    repurchase: 'product.repurchase',
    welcome: 'newsletter.welcome',
    cart_second: 'cart.abandoned.second',
    birthday: 'customer.birthday',
};
export const AUTOMATIONS_DEFAULTS = {
    reviewRequest: { enabled: false, days: 7 },
    winBack: { enabled: false, days: 90, discountPercent: null, discountHours: 72 },
    repurchase: { enabled: false },
    welcome: { enabled: false, discountId: null },
    birthday: { enabled: false, discountPercent: null, discountHours: 168, points: 0 },
};
export const AUTOMATION_LIMITS = { days: 365, discountPercent: 50, discountHours: 720, repurchaseDays: 730 };
/** How far past its delay a sweep looks: switching one on never mails a store's whole history. */
export const AUTOMATION_LOOKBACK_DAYS = 14;
export const TRACKING_DEFAULTS = { opens: true, clicks: true };
/** The tags a marketing mail's store links carry, so its orders land in Reports → Sources (ADR-097). */
export const MAIL_UTM = { source: 'newsletter', medium: 'email' };
/** An automation's campaign tag: `auto-review-request`. */
export function automationTag(key) {
    return `auto-${key.replace(/_/g, '-')}`;
}
// ─── Subscribers ─────────────────────────────────────────────────────────────
export const SUBSCRIBER_STATUSES = ['confirmed', 'pending', 'withdrawn'];
//# sourceMappingURL=automations.js.map